export default __webpack_public_path__ + "static/media/starter-box.f504f388.png";